enum IconSelector {
	Home,
	Assignment,
	BarChart,
	Dashboard,
	OpenWith,
	OpenInNew,
	AccountTree,
	Person,
	Groups,
	EventRepeat,
	SettingsApplications,
	Settings,
	Api,
	CropFree,
	ChevronRight,
	Delete,
	Add,
	AddBox,
	Close,
	Menu,
	Notifications,
	ChevronLeft,
	ExpandMore,
	QuestionMark,
	KeyboardDoubleArrowLeft,
	KeyboardDoubleArrowRight,
	KeyboardDoubleArrowDown,
	KeyboardDoubleArrowUp,
	KeyboardArrowDown,
	KeyboardArrowRight,
	KeyboardArrowUp,
	ErrorOutlined,
	ErrorOutlineOutlined,
	CheckCircle,
	Search,
	AccessTimeFilledOutlined,
	FormatListBulletedOutlined,
	RuleOutlinedIcon,
	AbcOutlinedIcon,
	DataObjectOutlinedIcon,
	PinOutlinedIcon,
	List,
	Fullscreen,
	FullscreenExit,
	ArrowDropDownIcon,
	ArrowRightIcon,
	Refresh,
	Save,
	AddToPhotos,
	Sync,
	CheckCircleOutline,
	InfoIcon,
	MergeIcon,
	ContentCopyIcon,
	Warning,
	PlayArrow,
	ManageAccountsIcon,
	Visibility,
	VisibilityOff,
	Edit,
	Group,
	Key,
	Google,
	SkipPrevious,
	SkipNext,
	DataArray,
	Event,
	CancelIcon,
	Lock,
	Upload,
	AutoFixHigh,
	NavigateNextIcon,
	NavigateBeforeIcon,
	DoneIcon,
	RemoveIcon,
	VpnLock,
	AutoGraphIcon,
	ChevronUp,
	ChevronDown,
	MenuIcon,
	DragIndicatorIcon,
	PhishingIcon,
	FileUploadIcon,
	GetAppIcon,
	RuleIcon,
	AccessTimeIcon,
	StorageIcon,
	CallSplitIcon,
	CallMergeIcon,
	CodeIcon,
	CompressIcon,
	InsertDriveFileIcon,
	LoopIcon,
	LayersIcon,
	Check,
	s3Icon,
	MethodDataIcon,
	SalesForceIcon,
	HubSpotIcon,
	ShopifyIcon,
	AwsIcon,
	LinkIcon,
	ImportExportIcon,
	StopIcon,
	TroubleshootIcon,
	CalendarMonthOutlinedIcon,
	LiveHelp,
	Send,
	DragHandle,
	MultipleStopIcon,
	Sort,
	ContentPaste,
	PlaylistAdd,
	Contacts,
	UpgradeIcon,
	SelectAll,
	Deselect,
	XeroIcon,
	Test,
}
export default IconSelector;
